import Vue from 'vue'
import {formatNum} from './index'

export default (() => {
  Vue.filter('dateYearMon', (date) => {
    return `${date.getFullYear()}年${date.getMonth() + 1}月`
  })

  Vue.filter('money', function(value) {
		if (typeof value === 'object' && value[1]) {
			return formatNum(value[0])
		} else {
			return formatNum(value, true, true)
		}
	})
})()
